module.exports = __webpack_public_path__ + "5f8a3644af81799b58ffb6f14da6d6f5.glb";